import {
  ACTIONS,
  GENERAL_RULES_CONSTANTS,
  TASK_FORM_LABELS
} from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import {
  LIST_ACCESS,
  LIST_CONSTANTS
} from "@/modules/List/constants/ListConstants";
import { ListService } from "@/modules/List/services/ListService";
import { ServiceHeaderData } from "@/modules/Services/models/ServiceHeaderData";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import { AxiosError } from "axios";
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import Vuetify from "vuetify";

Vue.use(Vuetify);
@Component({
  name: "ChangeStateService",
  components: { DynamicSelect }
})
export default class ChangeStateService extends Vue {
  @Prop() showStateServiceModal!: boolean;
  @Prop() serviceToChangeState!: ServiceHeaderData;

  @Inject() listService!: ListService;

  TITLES = GENERAL_RULES_CONSTANTS.TITTLES;
  ACTIONS = ACTIONS;
  TASK_FORM_LABELS = TASK_FORM_LABELS;
  cardClass = STYLE_CLASSES.CARD;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  secondaryBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  serviceStateFieldsValidation = false;
  FieldListServiceStateModel = [] as DynamicSelectData[];
  FieldSelectConfigServiceState: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: true,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: GENERAL_RULES_CONSTANTS.LABEL.SELECT_SERVICE,
    hideDetails: false,
    rules: [
      FORM_VALIDATORS.REQUIRED_LIST,
      FORM_VALIDATORS.REQUIRED_OBJECT_FILLED
    ],
    attach: false
  };

  mounted() {
    this.getServiceStates();
  }

  cancel() {
    this.$emit("closeStateServiceModal");
  }

  save() {
    this.$emit("updateStateService", {
      id: this.serviceToChangeState.id,
      state: this.FieldListServiceStateModel[0].id
    });
  }

  async getServiceStates() {
    try {
      const serviceStatesResponse = await this.listService.getListOptionsByName(
        LIST_CONSTANTS.SERVICE_STATES_LIST_NAME
      );
      if (
        serviceStatesResponse.code === Http.Found &&
        serviceStatesResponse.data !== undefined
      ) {
        this.FieldSelectConfigServiceState.listAll = serviceStatesResponse.data.map(
          state => {
            return {
              id: state.id as string,
              name: state.title as string
            };
          }
        );
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + LIST_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }
}
